import { render, staticRenderFns } from "./IconSvgDocument.vue?vue&type=template&id=607964fb&scoped=true&"
import script from "./IconSvgDocument.vue?vue&type=script&lang=js&"
export * from "./IconSvgDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607964fb",
  null
  
)

export default component.exports